var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"heatmap"},_vm._l((_vm.events),function(day,index){return _c('div',{key:index,staticClass:"heatmap__item",class:day.isDone ? 'heatmap__item--done' : ''})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }